import { LT_FEATURE_FLAG_UPDATE } from '../constants/featureFlag';

import { FeatureFlag } from 'constants/feature-flags';

const initialState = {};

function featureFlag(state = initialState, actions) {
  const { type, payload } = actions;
  switch (type) {
    case LT_FEATURE_FLAG_UPDATE:
      const flags = payload?.data || [];

      const featureFlags = { ...FeatureFlag };
      Object.keys(featureFlags).forEach((key) => {
        featureFlags[key] = flags.includes(featureFlags[key]);
      });

      return {
        ...state,
        ...featureFlags,
      };
    default:
      return state;
  }
}

export default featureFlag;
